/* global Office */

/**
 * Opens an external URL in the system browser.
 *
 * Prefers Office's openBrowserWindow (OpenBrowserWindowApi 1.1), which reliably
 * opens the default browser from the Outlook desktop WebView2 host where
 * window.open can be suppressed. Falls back to a standard new-tab open (Outlook
 * on the web, or hosts without the requirement set).
 */
export function openExternalUrl(url: string): void {
  if (typeof Office !== 'undefined' && Office.context?.ui?.openBrowserWindow) {
    Office.context.ui.openBrowserWindow(url)
    return
  }
  globalThis.open(url, '_blank', 'noopener,noreferrer')
}
